"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("../icons");
const classnames_1 = __importDefault(require("classnames"));
require("./styles.scss");
const Pagination = (props) => {
    const { current, amount, visible, selectPage } = props;
    const left = current - Math.floor(visible / 2);
    const right = current + Math.floor(visible / 2);
    const isLeftDotsVisible = left - 1 >= 2 && visible + 2 < amount;
    const isRightDotsVisible = right + 2 <= amount && visible + 2 < amount;
    let startIndex = 2;
    if (isLeftDotsVisible && isRightDotsVisible) {
        startIndex = current - Math.floor(visible / 2);
    }
    else if (!isRightDotsVisible) {
        startIndex = amount - visible;
    }
    const isFirstPageSelected = current === 1;
    const isLastPageSelected = current === amount;
    const firstPageClasses = (0, classnames_1.default)("c-pagination__page", { "c-pagination__page--active": isFirstPageSelected });
    const prevClasses = (0, classnames_1.default)("c-pagination__prev", { "c-pagination__prev--disabled": isFirstPageSelected });
    const lastPageClasses = (0, classnames_1.default)("c-pagination__page", { "c-pagination__page--active": isLastPageSelected });
    const nextClasses = (0, classnames_1.default)("c-pagination__next", { "c-pagination__prev--disabled": isLastPageSelected });
    const pages = Array(visible)
        .fill(0)
        .map((_, index) => index + startIndex)
        .filter((page) => page < amount && page > 1);
    const createChangePageHandler = (page) => () => selectPage(page);
    return (react_1.default.createElement("div", { className: "c-pagination" },
        react_1.default.createElement("div", { className: prevClasses, onClick: !isFirstPageSelected ? createChangePageHandler(current - 1) : undefined },
            react_1.default.createElement(icons_1.ArrowDownIcon, { color: "gray" })),
        react_1.default.createElement("div", { className: firstPageClasses, onClick: createChangePageHandler(1) }, "1"),
        isLeftDotsVisible && react_1.default.createElement("div", { className: "c-pagination__dots" }, "..."),
        pages.map((page) => {
            const pageClasses = (0, classnames_1.default)("c-pagination__page", { "c-pagination__page--active": page === current });
            return (react_1.default.createElement("div", { key: page, onClick: createChangePageHandler(page), className: pageClasses }, page));
        }),
        isRightDotsVisible && react_1.default.createElement("div", { className: "c-pagination__dots" }, "..."),
        amount > 1 && (react_1.default.createElement("div", { className: lastPageClasses, onClick: createChangePageHandler(amount) }, amount)),
        react_1.default.createElement("div", { className: nextClasses, onClick: !isLastPageSelected ? createChangePageHandler(current + 1) : undefined },
            react_1.default.createElement(icons_1.ArrowDownIcon, { color: "gray" }))));
};
exports.Pagination = Pagination;
